<template lang="pug">
f7-page#curriculums
  navbar(title="カリキュラム")

  f7-fab.create-button(
    position="right-bottom"
    slot="fixed"
    @click="showCreate")
    f7-icon(
      ios="f7:add"
      md="material:add")

  background
    curriculums-query(fetchPolicy="network-only")
      .curriculums(slot-scope="{ sentCurriculums, draftCurriculums }")
        template(v-if="draftCurriculums.length > 0")
          label 未送信 - 編集可
          draft-curriculum-list(
            :curriculums="draftCurriculums"
            @click="showDraftCurriculum")

        template(v-if="sentCurriculums.length > 0")
          label 送信済み - 編集不可
          curriculum-list(
            :curriculums="sentCurriculums"
            @click="showDetail")
</template>

<style lang="scss" scoped>
.curriculums {
  padding-top: 12px;
}

label {
  @extend %label-text;
  display: flex;
  align-items: center;
  padding-left: 16px;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.08);
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import CurriculumsQuery from '@/components/queries/CurriculumsQuery'
import CurriculumList from '@/components/organisms/CurriculumList'
import DraftCurriculumList from '@/components/organisms/DraftCurriculumList'
import FloatingButton from '@/components/atoms/FloatingButton'

export default {
  mixins: [PageTitle],
  title: 'カリキュラム',
  components: {
    CurriculumsQuery,
    DraftCurriculumList,
    CurriculumList,
    FloatingButton,
  },
  methods: {
    showCreate() {
      this.$f7router.navigate('/curriculums/create')
    },
    showDetail(curriculumId) {
      this.$f7router.navigate(`/curriculums/${curriculumId}/show`)
    },
    showDraftCurriculum(curriculumId) {
      this.$f7router.navigate(`/curriculums/${curriculumId}/edit`)
    },
  },
}
</script>
